import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/variables/';

/**
 * GET ariabless
 * @returns {Promise<Array<object>>}
 */
export const getVariables = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Variable
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getVariable = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Variable
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVariable = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Variable
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchVariable = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Variable
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteVariable = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
